<script setup lang="ts">
import type { GradeCode } from '~/models/Grade'
import type { ContentProductHeader } from '~/models/Content/ContentProductHeader'
import { useI18n } from 'vue-i18n'
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
import AuAccordionItem from '~/components/ui/AuAccordionItem.vue'
import AuAccordion from '~/components/ui/AuAccordion.vue'
import OldExamSubject from '~/components/products/exams/OldExamSubject.vue'

const { exams, selectedGrades, isLoading } = defineProps<{
  exams: ContentProductHeader[]
  selectedGrades: GradeCode[]
  isLoading: boolean
}>()

const { t } = useI18n()
</script>

<template>
  <section
    v-if="!isLoading"
    class="space-y-2"
  >
    <h2
      class="text-2xl font-bold"
      v-text="t('termExam.earlier')"
    />
    <p class="mb-4" v-text="t('termExam.earlierDescription')" />
    <AuAccordion type="multiple">
      <template v-for="exam in exams" :key="exam.locationId">
        <AuAccordionItem
          :value="`accordion-${exam.locationId}`"
          :title="exam.title"
          size="xl"
          shade="light"
          color="blue"
        >
          <OldExamSubject
            :exam="exam"
            :selected-grades="selectedGrades"
          />
        </AuAccordionItem>
      </template>
    </AuAccordion>
  </section>
  <AuSkeletonWrapper v-else>
    <AuSkeleton
      height="30px"
      width="150px"
    />
    <ul class="mt-2 flex flex-col gap-3">
      <AuSkeleton
        v-for="item in 3"
        :key="item"
        height="60px"
      />
    </ul>
  </AuSkeletonWrapper>
</template>
